export let ExperimentKeys;

(function (ExperimentKeys) {
  ExperimentKeys["ACQ0140"] = "acq-0140";
  ExperimentKeys["ACQ0142"] = "acq-0142";
})(ExperimentKeys || (ExperimentKeys = {}));

export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';